///<reference path="../Core/Resources.js"/>
window.localizedStrings["grid"] = {
  valueerror: "Could not set value on inline editor",
  recordcount: " ({0} records)",
  controlnotfounderror:
    "Could not find inline editor control {0} for notification",
  controlopenerror: "Editor not open for validation notification",
  validation: "You must either approve or delete your grid changes to continue",
  confirmdelete: "Are you sure you want to delete?",
  confirmdeletetitle: "Confirm Delete",
  confirmdeletedetail:
    "You will not be able to recover the data after it is deleted.",
  missingcolumnerror: "Could not find column {0} for zooming",
  valuetext: "Value",
  morerecords: "+",
  querytotal: "Get Full Record Count",
  querytotaltooltip: "Query to obtain the full record count",
  pagecountof: "of",
  editmodeentered: "Grid edit mode entered",
  normalmode: "Normal grid mode entered",
  todayfilter: "today",
  equalfilter: "equals"
};
